// extracted by mini-css-extract-plugin
module.exports = {"loginContainer":"loginContainer_kUuHW","loginContent":"loginContent_-J36u","oktaSimpleFooter":"oktaSimpleFooter_1EeJW"};